module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external "angular-toastr/dist/angular-toastr.css"
// module id = 13
// module chunks = 0